import { IItemPromoPrice } from "@faire/web-api/indigofair/data/IItemPromoPrice";
import isUndefined from "lodash/isUndefined";

interface IValidItemPromoPrice extends IItemPromoPrice {
  discount_bps: NonNullable<IItemPromoPrice["discount_bps"]>;
  discounted_item_price: NonNullable<IItemPromoPrice["discounted_item_price"]>;
}

export const showProductPromotions = (
  promoPrice?: IItemPromoPrice
): promoPrice is IValidItemPromoPrice => {
  if (!promoPrice) {
    return false;
  }
  return (
    !isUndefined(promoPrice.discount_bps) &&
    !isUndefined(promoPrice.discounted_item_price)
  );
};
